import { Component, Input } from '@angular/core';

import { SiteModel } from '@models/sites/sites.store';

import { Utils } from '@shared/utils/utils';

interface ExtendedSite extends SiteModel {
  address_2: string;
  address_3: string;
  country_name: string;
  investigator_name?: string;
  primary_investigator_name: string;
}

@Component({
  selector: 'aux-site-information-view',
  templateUrl: './site-information-view.component.html',
})
export class SiteInformationViewComponent {
  addressFields: (keyof ExtendedSite)[] = ['country_name', 'address_2', 'address_3'];
  @Input() site!: ExtendedSite;
  zeroHyphen = Utils.zeroHyphen;
}
